import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import MatrixUserCard from './MatrixUserCard'
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { Loader } from "@progress/kendo-react-indicators";
import api from '../FetchComponents/FetchComponentsServices'

const SyncModal = ({ toggleDialog, matrixUserData, oSUidmId}) => {
    const [multipleMatrixUsers, setMultipleMatrixUsers] = useState(matrixUserData.length > 1);
    const [selectedMatrixUser, setSelectedMatrixUser] = useState(matrixUserData[0]);
    const [matrixUsers, setMatrixUsers] = useState([]);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMSG, setErrorMSG] = useState('');
    const [syncing, setSyncing] = useState(false);
    const columns = [
        {
            field: "card",
            header: "Matrix Record",
            width: "500px",
        }
    ]

    const handleUpdate = async () => {
        setSyncing(true);
        try {
            const personID = selectedMatrixUser.find((user) => user.key === 'personID')?.value?.toString();
            const response = await api.syncUser(oSUidmId, personID);
            if (response?.success) {
                setSuccess(true);
            } else {
                setError(true);
                setErrorMSG(response?.note ?? "Sync failed. See Logs for more details.");
            }

        } catch (err) {
            setErrorMSG(err?.message ?? "An unexpected error occurred.");
            setError(true);
        } finally {
            setSyncing(false);
        }
    }

    const capitalizeKeys = (obj) => {
        if (obj !== null && typeof obj === 'object') {
            if (Array.isArray(obj)) {
                return obj.map(capitalizeKeys);
            } else {
                return Object.fromEntries(
                    Object.entries(obj).map(([key, value]) => [
                        key.charAt(0).toUpperCase() + key.slice(1),
                        capitalizeKeys(value),
                    ])
                );
            }
        } else {
            return obj;
        }
    }

    const formatUser = (obj) => {
        if (obj !== null && typeof obj === 'object') {
            if (Array.isArray(obj)) {
                return obj.map(formatUser);
            } else {
                return Object.fromEntries(
                    Object.entries(obj).map(([key, value]) => [
                        key.charAt(0).toUpperCase() + key.slice(1),
                        convertBooleanValues(value),
                    ])
                );
            }
        } else {
            return convertBooleanValues(obj);
        }
    }

    const convertBooleanValues = (value) => {
        if (typeof value === 'string') {
            const lowercaseValue = value.toLowerCase();
            if (lowercaseValue === 'true') {
                return true;
            } else if (lowercaseValue === 'false') {
                return false;
            }
        }
        return value;
    }

    const handleChange = (event) => {
        if (event) {
            setSelectedMatrixUser(matrixUserData.find((user) => user.some(obj => obj.key === 'personID' && obj.value === event.value.card)))
            setMultipleMatrixUsers(false)
        }
    };

    const handleBack = () => {
        setMultipleMatrixUsers(true)
    }

    const itemRender = (li, props) => {
        const children = columns.map((col, i) => {
            return (
                <span className="k-table-td" style={{ width: col.width }} key={col.width + i}>
                    <MatrixUserCard userData={matrixUserData.find((user) => user.some(obj => obj.key === 'personID' && obj.value === props.dataItem[col.field]))} index={props.dataItem[col.field]} />
                </span>
            );
        });
        return React.cloneElement(
            li,
            {
                ...li.props,
            },
            children
        );
    };

    const getTitle = () => {
        let title = 'Please Confirm Sync Action'
        if (error) {
            title = 'Error'
        }
        if (success) {
            title = 'Success'
        }
        return title;
    }

    useEffect(() => {
        if (matrixUserData) {
            if (matrixUserData.length === 1) {
                setMultipleMatrixUsers(false)
                setSelectedMatrixUser(matrixUserData[0])
            } else {
                setMultipleMatrixUsers(true)
                setSelectedMatrixUser(matrixUserData[0])
                setMatrixUsers(matrixUserData.map((user, index) => {
                    return {
                        'id': index,
                        'card': user.find((user) => user.key === 'personID').value
                    }
                }))
            }
        }
    }, [])

    return (
        <Dialog title={getTitle()} onClose={toggleDialog}>
            {error
                ? <div className='warning'>{errorMSG}</div>
                : <div className='modal-body'>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        {
                            success
                                ? 'User successfully synced'
                                : multipleMatrixUsers
                                    ? 'Choose the Matrix Record You Want to Sync to:'
                                    : 'Are you sure you want to sync to this record?'
                        }
                    </p>
                    <MatrixUserCard userData={selectedMatrixUser} index={0} />
                    <div className='combobox-container'>
                        {
                            multipleMatrixUsers &&
                            <MultiColumnComboBox
                                data={matrixUsers}
                                columns={columns}
                                textField={"card"}
                                itemRender={itemRender}
                                onChange={handleChange}
                                className={'user-card-select'}
                                placeholder={selectedMatrixUser.find((user) => user.key === 'personID')?.value.toString()}
                            />
                        }
                    </div>
                    {!multipleMatrixUsers && !success &&
                        <DialogActionsBar>
                            {matrixUsers.length > 1 && <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleBack}>Change User</button>}
                            <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={toggleDialog}>No</button>
                            <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" disabled={syncing} onClick={handleUpdate}>{syncing ? <Loader size='small' type={"infinite-spinner"} /> : 'Yes'}</button>
                        </DialogActionsBar>
                    }
                    {success && <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={toggleDialog}>Close</button>
                    </DialogActionsBar>
                    }
                </div>
            }
        </Dialog>
    );
}

export default SyncModal;